export interface GenerateAITransformationTestColumn {
    FieldId: number;
    Name: string;
}

export interface GenerateAITransformationTestRow {
    // Displayed value of each input field by field id, null when the value is empty.
    Inputs: Record<string, string | null>;
    Output: string | null;
}

class GenerateAITransformationResult {
    // Raw JSON settings of the generated (Combined) transformation.
    Settings: string;
    // Label of each AI-accessible transformation by logic id, to name the steps of the settings.
    Labels: Record<string, string>;
    // Execution of the settings on fake data: every combination of empty / filled nullable inputs with its output.
    InputColumns: GenerateAITransformationTestColumn[];
    OutputColumnName: string;
    Rows: GenerateAITransformationTestRow[];
    // Why the settings failed on the fake data (they are still returned to be inspected), empty when the test passed.
    Error: string;

    constructor(settings: string, labels: Record<string, string>, inputColumns: GenerateAITransformationTestColumn[] = [], outputColumnName: string = "", rows: GenerateAITransformationTestRow[] = [], error: string = "") {
        this.Error = error;
        this.Settings = settings;
        this.Labels = labels;
        this.InputColumns = inputColumns;
        this.OutputColumnName = outputColumnName;
        this.Rows = rows;
    }
}

export default GenerateAITransformationResult;
